// @mui
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Stack,
  Typography,
} from '@mui/material'
// components
import PreviewForm from 'domains/Users/Verification/containers/PreviewForm'
import Layout from '~/layouts'
import Page from 'components/Page'
import HeaderBreadcrumbs from 'components/HeaderBreadcrumbs'
// hooks
import useSettings from 'hooks/useSettings'
// constants
import { PATH_DASHBOARD } from 'routes/paths'
import { TERMS_CONDITION_URL } from '~/config'
import config from 'configs/app'
import useLocales from 'hooks/useLocales'

export default function PendingPage() {
  const { t } = useLocales()
  const { themeStretch } = useSettings()

  return (
    <Layout>
      <Page title={t('key_data_verification_input')}>
        <Container maxWidth={themeStretch ? false : 'xl'}>
          <HeaderBreadcrumbs
            heading={t('key_data_verification_input')}
            links={[
              { name: 'Dashboard', href: PATH_DASHBOARD.root },
              {
                name: t('key_data_verification'),
                href: PATH_DASHBOARD.general.verification.root,
              },

              {
                name: t('key_data_verification_input'),
              },
            ]}
          />
          <Box
            sx={(theme) => ({
              [theme.breakpoints.up('md')]: {
                maxWidth: '720px',
              },
              margin: '0px auto',
            })}
          >
            <PreviewForm
              title={t('key_verify_your_data')}
              subtitle={t(
                'key_your_data_is_in_the_verification_process_please_wait_a_maximum_of_1x24_hours_on_working_days',
              )}
              reducedOpacity
              badge={
                <Stack
                  direction="row"
                  sx={(theme) => ({
                    borderRadius: '6px',
                    padding: '1px 8px',
                    backgroundColor: theme.palette.error.main,
                    gap: 0.5,
                    alignItems: 'center',
                  })}
                >
                  <Typography
                    variant="overline"
                    sx={(theme) => ({
                      color: theme.palette.common.white,
                      textTransform: 'none',
                    })}
                  >
                    {t('key_bank_verify_process')}
                  </Typography>
                </Stack>
              }
              customFooter={
                <>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>

                  <Grid item xs={12} justifyContent="center">
                    <Typography variant="body2">
                      {t('key_if_your_data_has_not_been_verified')}
                    </Typography>
                    <Stack direction="row" gap={1} marginTop="18px">
                      <Button
                        id="b-users-pendingpage-terms"
                        variant="outlined"
                        sx={{ flex: 1 }}
                        onClick={() => {
                          window.open(
                            `${TERMS_CONDITION_URL}#Aplikasi,-Akun-dan-Keamanan`,
                            '_blank',
                          )
                        }}
                      >
                        {t('key_terms_and_conditions')}
                      </Button>
                      <Button
                        id="b-users-pendingpage-contact-cs"
                        variant="contained"
                        sx={{ flex: 1 }}
                        onClick={() => {
                          window.open(
                            config.supportCenterUrl + 'home',
                            '_blank',
                          )
                        }}
                      >
                        {t('key_contact_cs')}
                      </Button>
                    </Stack>
                  </Grid>
                </>
              }
              showDefaultCTA={false}
              setActiveStepEditBank={undefined}
            />
          </Box>
        </Container>
      </Page>
    </Layout>
  )
}
